(function ($) {
  var $document = $(document);
  $document.ready(function () {
    $('.header .box-btn, .header-nav-bg').click(function () {
      setTimeout(function () {
        if ($('body').hasClass('open-nav')) {
          setCookie('openNav', 1, 10);
          delCookie('closeNav');
        } else {
          delCookie('openNav');
        }
      }, 800);
    });
    $('.header-nav .nav a').click(function () {
      setCookie('closeNav', 1, 10);
      delCookie('openNav');
    });
    $('.js-move').click(function (e) {
      e.preventDefault();
      $(this).parents('.block-list-item').eq(0).removeClass('not-sortable').removeClass('open-actions');
      $(this).addClass('active');
      $('.block-list-sortable').sortable('enable');
    });
    $('.js-edit').click(function (e) {
      e.preventDefault();

      if ($(this).closest('.box-icons').find('> .block-popup-edit').html().length) {
        openPopupEdit($(this));
      } else {
        directory_edit($(this));
      }
    });
    $('.js-new').click(function (e) {
      e.preventDefault();
      $('.block-list-item, .table-list-item').removeClass('open-actions');
      $('.block-list-sortable').find('.block-list-item').addClass('not-sortable').find('.box-actions-item').removeClass('active');
      $('.block-list-sortable').sortable('disable');
      $('.block-popup-edit[data-directory="' + $(this).data('directory') + '"]').addClass('open-popup');
    });
    $('.dashboard-personal-area .block-list-sortable').on('sortstop', function (event, ui) {
      directoryPostSort($(this));
    });
    $('.table-list-sortable').on('sortstop', function (event, ui) {
      directoryListSort($(this));
    });
    $('.js-delete').click(function (e) {
      e.preventDefault();
      $('.block-list-item, .table-list-item').removeClass('open-actions');
      $('.block-list-sortable').find('.block-list-item').addClass('not-sortable').find('.box-actions-item').removeClass('active');
      $('.block-list-sortable').sortable('disable');
      $(this).closest('.box-icons').find('> .block-popup-delete').addClass('open-popup');
    });
    $('.js-delete-approve').click(function (e) {
      e.preventDefault();
      var parentGeneral = $(this).parents('.block-list').eq(0);
      var $parent = $(this).parents('.accordion-content').eq(0);
      var postId = $(this).parents('.directory-item').eq(0).data('id');
      $parent.find('.directory-item:hidden').eq(0).removeClass('block-list-item-hidden');
      $(this).parents('.directory-item').eq(0).remove();
      var itemsLength = $parent.find('.directory-item').length;
      $('.block-list-item a[data-type="' + $parent.find('.block-list').data('type') + '"]').find('.count').text(itemsLength);

      if (itemsLength <= 3) {
        $parent.find('.block-more').css({
          display: 'none'
        });
      }

      directoryPostDelete(postId, parentGeneral);
      $(this).parents('.block-popup').eq(0).removeClass('open-popup');
    });
    $('.js-del-from-list').click(function (e) {
      e.preventDefault();
      var parentGeneralId = $(this).parents('.directory-item').eq(0).data('id');
      var postId = $(this).parents('.block-list-item').eq(0).data('id');
      directoryPostDelFromList(postId, parentGeneralId);
      $(this).parents('.block-popup').eq(0).removeClass('open-popup');
      $(this).parents('.block-list-item').eq(0).remove();
    });
    $('.js-bookmark-del').click(function (e) {
      e.preventDefault();
      var postId = $(this).data('id');
      directoryPostDelete(postId, $(this).parent());
      $(this).find('i').removeClass('icon-bookmark-full').addClass('icon-bookmark');
    });
    $('.js-delete-checked-approve').click(function (e) {
      e.preventDefault();
      directoryListPostsDelete($(this));
      $(this).parents('.block-popup').eq(0).removeClass('open-popup');
    });
    $('.js-delete-checked').click(function (e) {
      e.preventDefault();

      if ($(this).parents('.block-content').eq(0).find('.table-list-item:not(.table-list-item-head)').find('[name="selected_item"]').is(':checked')) {
        $('.block-list-item, .table-list-item').removeClass('open-actions');
        $(this).closest('.box-btn-list').find('.block-popup-delete').addClass('open-popup');
      }
    });
    $('.js-cancel').click(function (e) {
      e.preventDefault();
      $('.block-list-item, .table-list-item').removeClass('open-actions');
      $(this).closest('.block-popup').removeClass('open-popup');
      $(this).closest('.block-popup').find('.box-title').removeClass('edit-title');
      $(this).closest('.block-popup').find('.box-subtitle').removeClass('edit-subtitle');
      $(this).closest('.block-popup').find('.box-new-list').removeClass('edit-new-list');
      $(this).closest('.block-popup').find('.form-control-wrap').removeClass('focused filled');
      $(this).closest('.block-popup').find('.file-drop-upload').removeClass('active').find('.file-text').text('Datei hochladen');
      $(this).closest('.block-popup').find('form').trigger('reset');

      if ($(this).closest('.block-popup').find('.form-control-wrap').find('textarea').val()) {
        $(this).closest('.block-popup').find('.form-control-wrap').addClass('filled');
      }

      $(this).parents('.block-content').eq(0).find('.error').remove();
      $('#penbutton').remove();
    });
    $('.js-save').click(function (e) {
      e.preventDefault();

      if (!$(this).parents('.block-content').eq(0).find('.error').length) {
        $(this).parents('.block-popup').eq(0).removeClass('open-popup');
      }

      directoryPostSave($(this));
    });
    $('.js-show-pass').click(function () {
      var passwordField = $(this).parents('.password-input-wrapper').find('.password-input');
      passwordField.attr('type', passwordField.attr('type') === 'password' ? 'text' : 'password');
    });
    $('.js-profile-cancel').click(function (e) {
      e.preventDefault();
      $(this).parents('form').find('.file-drop-upload').removeClass('active').find('.file-text').text('Drop file here');
      $(this).parents('form').trigger('reset');
    });
    $('.js-profile-form').submit(function (e) {
      e.preventDefault();
      sendProfileFormData($(this));
    });
    $('.js-profile-save').click(function (e) {
      e.preventDefault();
      sendProfileFormData($(this).parents('form'), $(this).closest('form').attr('data-alert'));
    });
    $document.on('change', '.post-file [name="post_file"]', function () {
      var fileValidLimit = true;
      var fileValidType = false;
      $(this).parents('.box-top').eq(0).find('.error').remove();
      var errorMessage = "";

      if (this.files[0].size > eFileSizeLimit) {
        fileValidLimit = false;
        errorMessage += "Die Gesamtgröße aller Anhänge ist zu groß. (Max " + eFileSizeLimitMB + "MB).";
      }

      if (eFileTypes.length) {
        for (var i = 0; i <= eFileTypes.length; i++) {
          if (this.files[0].name.indexOf(eFileTypes[i]) > 0) {
            fileValidType = true;
          }
        }
      }

      if (!fileValidType) {
        if (errorMessage.length) {
          errorMessage += '<br>';
        }

        errorMessage += "Das Hochladen ist für den Dateityp nicht erlaubt (" + eFileTypesStr + ").";
      }

      if (!fileValidLimit || !fileValidType) {
        $(this).parents('.box-top').eq(0).append('<div class="subtitle error" style="color: #E30513;">' + errorMessage + '</div>');
      }
    });
  });

  function directory_edit(el) {
    var elWrapp = el.closest('.box-icons').find('> .block-popup-edit');
    var postData = elWrapp.data('post');
    var data = {
      action: 'directory_edit',
      data: postData
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {
        $('.preloader').addClass('show-preloader').show();
      },
      success: function success(data) {
        setTimeout(function () {
          $('.preloader').hide();
        }, 300);

        if (data.content.length) {
          var popupEdit = $(data.content).html();
          elWrapp.html(popupEdit);
          initEventsAfterAjax(elWrapp);
          openPopupEdit(el);
        }
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function openPopupEdit(el) {
    $('.block-list-item, .table-list-item').removeClass('open-actions');
    $('.block-list-sortable').find('.block-list-item').addClass('not-sortable').find('.box-actions-item').removeClass('active');
    $('.block-list-sortable').sortable('disable');
    el.closest('.box-icons').find('> .block-popup-edit').addClass('open-popup');
  }

  function directoryPostSort(el) {
    var $nonce = $('.dashboard-personal-area').data('wpnonce');
    var $items = [];
    el.find('.block-list-item:visible').each(function () {
      var $itemData = {
        id: $(this).data('id'),
        index: $(this).index() + 1
      };
      $items.push($itemData);
    });
    var data = {
      action: 'directory_post_sort',
      items: $items,
      wpnonce: $nonce
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {},
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function directoryListSort(el) {
    var $nonce = $('.user-directory').data('wpnonce');
    var $items = [];
    var elParent = el.parents('.block-popup').eq(0);
    var postData = elParent.data('post');
    el.find('.table-list-item:visible').each(function () {
      var $itemData = {
        id: $(this).data('id'),
        index: $(this).index() + 1
      };
      $items.push($itemData);
    });
    var data = {
      action: 'directory_list_sort',
      items: $items,
      postData: postData,
      wpnonce: $nonce
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {},
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function directoryListEdit(el) {
    var elParent = el.parents('.directory-item').eq(0);
    var postId = elParent.data('id');
    var data = {
      action: 'directory_list_edit',
      postId: postId
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        elParent.find('.block-popup-edit').html($(data.content));
        $('.block-list-item, .table-list-item').removeClass('open-actions');
        $('.block-list-sortable').find('.block-list-item').addClass('not-sortable').find('.box-actions-item').removeClass('active');
        $('.block-list-sortable').sortable('disable');
        el.closest('.box-icons').find('> .block-popup-edit').addClass('open-popup');
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function directoryPostDelete(postId, parentGeneral) {
    var $nonce = $('.user-directory').data('wpnonce');
    var data = {
      action: 'directory_post_delete',
      postId: postId,
      wpnonce: $nonce
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {
        setTimeout(function () {
          document.location.reload();
        }, 600);
      },
      success: function success(data) {},
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function directoryPostDelFromList(postId, parentGeneralId) {
    var $nonce = $('.user-directory').data('wpnonce');
    var data = {
      action: 'directory_list_posts_delete',
      items: [{
        id: postId
      }],
      postData: {
        id: parentGeneralId
      },
      wpnonce: $nonce
    };
    $.ajax({
      url: reqObj.ajaxUrl,
      dataType: 'json',
      method: 'post',
      data: data,
      beforeSend: function beforeSend(xhr) {
        setTimeout(function () {
          document.location.reload();
        }, 600);
      },
      success: function success(data) {},
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function directoryListPostsDelete(el) {
    var $nonce = $('.user-directory').data('wpnonce');
    var $items = [];
    var elParent = el.parents('.block-popup').eq(1);
    var postData = elParent.data('post');
    elParent.find('.list-posts[data-id="' + postData.id + '"]').find('.table-list-item:visible:not(.table-list-item-head)').each(function () {
      if ($(this).find('[name="selected_item"]').is(':checked')) {
        var $itemData = {
          id: $(this).data('id')
        };
        $items.push($itemData);
      }
    });

    if ($items.length) {
      $.each($items, function (indx, elem) {
        elParent.find('.list-posts[data-id="' + postData.id + '"]').find('.table-list-item[data-id="' + elem.id + '"]').remove();
      });
      var data = {
        action: 'directory_list_posts_delete',
        items: $items,
        postData: postData,
        wpnonce: $nonce
      };
      $.ajax({
        url: reqObj.ajaxUrl,
        dataType: 'json',
        method: 'post',
        data: data,
        beforeSend: function beforeSend(xhr) {
          setTimeout(function () {
            document.location.reload();
          }, 600);
        },
        success: function success(data) {},
        error: function error(jqXHR, textStatus, errorThrown) {}
      });
    }
  }

  function directoryPostSave(el) {
    var isError = false;
    var elParent = el.parents('.block-popup').eq(0);
    var postData = elParent.data('post');

    if (el.parents('.block-content').eq(0).find('.box-top[data-id="' + postData.id + '"]').find('.error').length) {
      isError = true;
    }

    if (!isError) {
      var $nonce = $('.user-directory').data('wpnonce'); //var isReloadPage = false;

      var isReloadPage = true;
      postData.postTitle = elParent.find('[name="post_title"][data-id="' + postData.id + '"]').val();
      postData.postExcerpt = elParent.find('[name="post_excerpt"][data-id="' + postData.id + '"]').val();
      postData.post_link = elParent.find('[name="post_link"][data-id="' + postData.id + '"]').val();
      var $list = [];
      elParent.find('.list-data[data-id="' + postData.id + '"] .block-list-item').each(function () {
        if ($(this).find('[name="list_id"]').is(':checked')) {
          var $item = {};
          $item.list_id = $(this).find('[name="list_id"]').val();
          $item.list_name = $(this).find('[name="list_name"]').val();
          $item.list_order = $(this).find('[name="list_id"]').data('order');
          /*if ( $item.list_id == 'new' ) {
              isReloadPage = true;
          }*/

          $list.push($item);
        }
      });
      postData.list = $list;
      /*if (postData.type == 'e_list') {
          isReloadPage = true;
      }*/

      /*if ( $('.user-list-directory').length ) {
          isReloadPage = true;
      }*/

      var data = {
        action: 'directory_post_save',
        postData: postData,
        wpnonce: $nonce
      };
      /*if ( postData.postTitle ) {
          $('.item-title[data-id="' + postData.id + '"]').text(postData.postTitle);
      }*/
      //$('.item-text[data-id="' +  postData.id + '"]').html('<p>' + $('<p>' + postData.postExcerpt + '</p>').text().replace(/\r?\n/g, '<br>') + '</p>');
      //$('[name="post_excerpt"][data-id="' +  postData.id + '"]').text(postData.postExcerpt);

      if (postData.directory == 'e_document') {
        directoryPostFileSave(el, data, isReloadPage);
      } else {
        $.ajax({
          url: reqObj.ajaxUrl,
          dataType: 'json',
          method: 'post',
          data: data,
          beforeSend: function beforeSend(xhr) {
            if (isReloadPage && postData.directory !== 'e_document') {
              setTimeout(function () {
                document.location.reload();
              }, 600);
            }
          },
          success: function success(data) {},
          error: function error(jqXHR, textStatus, errorThrown) {}
        });
      }
    }
  }

  function directoryPostFileSave(el, elData, isReloadPage) {
    var elParent = el.parents('.block-popup').eq(0);
    var formFile = elParent.find('.post-file[data-id="' + elData.postData.id + '"]'); //elParent.find('.subtitle[data-id="' + elData.postData.id + '"]').text(elParent.find('.file-text[data-id="' + elData.postData.id + '"]').text());

    $('.subtitle[data-id="' + elData.postData.id + '"]').text(elParent.find('.file-text[data-id="' + elData.postData.id + '"]').text());
    var formFileData = new FormData(formFile.get(0));
    formFileData.append('postData', JSON.stringify(elData));
    $.ajax({
      url: formFile.attr('action'),
      type: 'POST',
      dataType: 'json',
      processData: false,
      contentType: false,
      data: formFileData,
      action: 'profile_data',
      beforeSend: function beforeSend(xhr) {},
      success: function success(data) {
        if (isReloadPage) {
          document.location.reload();
        }
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  }

  function sendProfileFormData($form, textAlert) {
    $form.removeClass('invalid');
    $form.find('[aria-invalid="true"]').each(function () {
      $(this).attr('aria-invalid', false).removeClass('not-valid');
    });
    $form.find('.error').remove();
    var formData = new FormData($form.get(0));
    var textAlert = textAlert;
    $.ajax({
      url: $form.attr('action'),
      type: 'POST',
      dataType: 'json',
      processData: false,
      contentType: false,
      data: formData,
      action: 'profile_data',
      beforeSend: function beforeSend(xhr) {
        $('#loading').addClass('show-preloader');
      },
      success: function success(data) {
        successProfileFormData(data, $form, textAlert);
        $('#loading').removeClass('show-preloader');
      },
      error: function error() {
        $('#loading').removeClass('show-preloader');
      }
    });
  }

  function successProfileFormData(data, $form, textAlert) {
    if (data.status) {
      document.location.reload();
    } else {
      $form.addClass('invalid');

      if (data.invalid_fields.length) {
        $.each(data.invalid_fields, function (name, value) {
          var $field = $('[name="' + value.key + '"]');
          $field.attr('aria-invalid', true).parents('div').eq(1).append('<span class="error" style="color: #E30513;">' + value.message + '</span>');
          $field.addClass('not-valid');
        });
        alert(textAlert);
      }
    }
  }

  function initEventsAfterAjax(el) {
    el.find('.box-title .icon-pen').click(function () {
      $(this).closest('.box-title').addClass('edit-title').find('.title-input').focus().select();
      $(this).closest('.box-title').next('.box-subtitle').addClass('edit-subtitle');
    });
    el.find('.js-cancel').click(function (e) {
      e.preventDefault();
      $('.block-list-item, .table-list-item').removeClass('open-actions');
      $(this).closest('.block-popup').removeClass('open-popup');
      $(this).closest('.block-popup').find('.box-title').removeClass('edit-title');
      $(this).closest('.block-popup').find('.box-subtitle').removeClass('edit-subtitle');
      $(this).closest('.block-popup').find('.box-new-list').removeClass('edit-new-list');
      $(this).closest('.block-popup').find('.form-control-wrap').removeClass('focused filled');
      $(this).closest('.block-popup').find('.file-drop-upload').removeClass('active').find('.file-text').text('Datei hochladen');
      $(this).closest('.block-popup').find('form').trigger('reset');

      if ($(this).closest('.block-popup').find('.form-control-wrap').find('textarea').val()) {
        $(this).closest('.block-popup').find('.form-control-wrap').addClass('filled');
      }

      $(this).parents('.block-content').eq(0).find('.error').remove();
    });
    el.find('.js-save').click(function (e) {
      e.preventDefault();

      if (!$(this).parents('.block-content').eq(0).find('.error').length) {
        $(this).parents('.block-popup').eq(0).removeClass('open-popup');
      }

      directoryPostSave($(this));
    }); // Accordion List

    el.find('.accordion-list-content').hide();
    el.find('.accordion-list-caption.active ~ .accordion-list-content').show();
    el.find('.accordion-list-caption').click(function () {
      $(this).next().slideToggle(300);
      $('.accordion-list-content').not($(this).next()).slideUp(300);
      $(this).toggleClass('active');
      $('.accordion-list-caption').not($(this)).removeClass('active');
    });
    el.find('.form-control').each(function () {
      var $field = $(this).closest('.form-control-wrap');

      if (this.value) {
        $field.addClass('filled');
        $field.addClass('focused');
      } else {
        $field.removeClass('filled');
        $field.removeClass('focused');
      }
    });
    el.find('.box-new-list input[type="checkbox"]').click(function () {
      if ($(this).is(':checked')) {
        $(this).closest('.box-new-list').addClass('edit-new-list').find('.new-list-input').focus().select();
      } else {
        $(this).closest('.box-new-list').removeClass('edit-new-list');
      }
    });
    el.find('.table-list-item-head input[type="checkbox"]').click(function () {
      if ($(this).is(':checked')) {
        $(this).closest('.table-list').find('.table-list-item:not(.table-list-item-head) input[type="checkbox"]').prop('checked', true);
      } else {
        $(this).closest('.table-list').find('.table-list-item:not(.table-list-item-head) input[type="checkbox"]').prop('checked', false);
      }
    });
    el.find('.js-delete-checked-approve').click(function (e) {
      e.preventDefault();
      directoryListPostsDelete($(this));
      $(this).parents('.block-popup').eq(0).removeClass('open-popup');
    });
    el.find('.js-delete-checked').click(function (e) {
      e.preventDefault();

      if ($(this).parents('.block-content').eq(0).find('.table-list-item:not(.table-list-item-head)').find('[name="selected_item"]').is(':checked')) {
        $('.block-list-item, .table-list-item').removeClass('open-actions');
        $(this).closest('.box-btn-list').find('.block-popup-delete').addClass('open-popup');
      }
    });
    el.find('.table-list-sortable').sortable({
      connectWith: '.table-list-sortable',
      items: '.table-list-item:not(.table-list-item-head)',
      cursor: 'move'
    });
    el.find('.js-edit').click(function (e) {
      e.preventDefault();

      if ($(this).closest('.box-icons').find('> .block-popup-edit').html().length) {
        openPopupEdit($(this));
      } else {
        directory_edit($(this));
      }
    });
    el.find('.table-list-sortable').on('sortstop', function (event, ui) {
      directoryListSort($(this));
    });
    el.find('.table-list-item .icon-ellipsis').click(function (e) {
      $(this).closest('.table-list-item').toggleClass('open-actions');
      $('.table-list-item').not($(this).closest('.table-list-item')).removeClass('open-actions');
    });
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "".concat(cname, "=").concat(cvalue, ";").concat(expires, ";path=/");
  }

  function getCookie(cname) {
    var name = "".concat(cname, "=");
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return '';
  }

  function delCookie(cname) {
    setCookie(cname, '', -1);
  }
})(jQuery);